/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminStockAdjustLocationOptionsLocationOptionVo
 */
export interface AdminStockAdjustLocationOptionsLocationOptionVo {
    /**
     * 货位ID
     * @type {number}
     * @memberof AdminStockAdjustLocationOptionsLocationOptionVo
     */
    locationId?: number;
    /**
     * 货位号
     * @type {string}
     * @memberof AdminStockAdjustLocationOptionsLocationOptionVo
     */
    locationNo?: string;
    /**
     * 货架使用类型
     * @type {number}
     * @memberof AdminStockAdjustLocationOptionsLocationOptionVo
     */
    useType?: number;
    /**
     * 货架尺寸类型
     * @type {number}
     * @memberof AdminStockAdjustLocationOptionsLocationOptionVo
     */
    sizeType?: number;
}

/**
 * Check if a given object implements the AdminStockAdjustLocationOptionsLocationOptionVo interface.
 */
export function instanceOfAdminStockAdjustLocationOptionsLocationOptionVo(value: object): value is AdminStockAdjustLocationOptionsLocationOptionVo {
    return true;
}

export function AdminStockAdjustLocationOptionsLocationOptionVoFromJSON(json: any): AdminStockAdjustLocationOptionsLocationOptionVo {
    return AdminStockAdjustLocationOptionsLocationOptionVoFromJSONTyped(json, false);
}

export function AdminStockAdjustLocationOptionsLocationOptionVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminStockAdjustLocationOptionsLocationOptionVo {
    if (json == null) {
        return json;
    }
    return {
        
        'locationId': json['locationId'] == null ? undefined : json['locationId'],
        'locationNo': json['locationNo'] == null ? undefined : json['locationNo'],
        'useType': json['useType'] == null ? undefined : json['useType'],
        'sizeType': json['sizeType'] == null ? undefined : json['sizeType'],
    };
}

export function AdminStockAdjustLocationOptionsLocationOptionVoToJSON(json: any): AdminStockAdjustLocationOptionsLocationOptionVo {
    return AdminStockAdjustLocationOptionsLocationOptionVoToJSONTyped(json, false);
}

export function AdminStockAdjustLocationOptionsLocationOptionVoToJSONTyped(value?: AdminStockAdjustLocationOptionsLocationOptionVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'locationId': value['locationId'],
        'locationNo': value['locationNo'],
        'useType': value['useType'],
        'sizeType': value['sizeType'],
    };
}

